import ENVIRONMENT from './environments';

const { BASE_URL } = ENVIRONMENT;

const apiRoutes = {
  BASE_URL,

  CHECKLISTS: `${BASE_URL}/resources/checklists`,
  REQUESTS: `${BASE_URL}/resources/request-forms`,
  BOOKING: `${BASE_URL}/resources/booking`,

  LOGIN: `${BASE_URL}/auth/login`,
  USER_INFO: `${BASE_URL}/auth/user`,
  RESET_EMAIL: `${BASE_URL}/auth/password/email`,
  RESET_PASSWORD: `${BASE_URL}/auth/reset-password`,
  CONTACT_REGISTER: `${BASE_URL}/auth/contact-register`,

  CUSTOMER_INVITE: `${BASE_URL}/billing/customer-invitations`,

  CHECKOUT_INFO: `${BASE_URL}/checkout/info`,
  CHECKOUT_SETUP: `${BASE_URL}/checkout/setup`,
  CHECKOUT_SUCCESS: `${BASE_URL}/checkout/success`,

  USERS: `${BASE_URL}/auth/users`,
  CONTACTS: `${BASE_URL}/billing/contacts`,
  CUSTOMERS: `${BASE_URL}/billing/customers`,

  PROJECT_TASKS: `${BASE_URL}/projects/tasks`,
  PROJECTS: `${BASE_URL}/projects/projects`,
  PROJECTS_LITE: `${BASE_URL}/projects/projects-lite`,
  PROJECT_RETAINER: `${BASE_URL}/projects/projects`,
  PROJECT_REQUEST: `${BASE_URL}/projects/requests`,
  PROJECT_WORK_LOGS: `${BASE_URL}/projects/work-logs`,
  INBOX: `${BASE_URL}/mentions/client-inbox`,
  MENTIONS: `${BASE_URL}/mentions`,
  MENTION_COUNT: `${BASE_URL}/mentions/count`,
  PROJECT_LOG: `${BASE_URL}/comments-report?filters[commentable_type][]=projects&sort[by]=created_at&sort[direction]=desc`,
  RESOURCES: `${BASE_URL}/cms/resources`,

  // COMMENTS
  COMMENTS: `${BASE_URL}/comments`,
  REACTION: `${BASE_URL}/reaction`,

  // UPLOAD
  CREATE_PRE_SIGNED: `${BASE_URL}/create-pre-signed-url`,
  UPLOADS: `${BASE_URL}/uploads`,

  MASS_DOWNLOAD: `${BASE_URL}/mass-download`,
  ANSWERS: `${BASE_URL}/forms/answers`,
  FORMS: `${BASE_URL}/forms/forms`,
  GLOBAL_SEARCH: `${BASE_URL}/client-global-search`,

  // ANALYTICS
  ANALYTICS_GOOGLE: `${BASE_URL}/google-analytics`,
  ANALYTICS_FB: `${BASE_URL}/facebook-analytics`,

  // NOTIFICATIONS
  NOTIFICATIONS: `${BASE_URL}/notifications`,
  FCM_TOKEN: `${BASE_URL}/fcm-token`,

  // SURVEY
  SURVEY_FEEDBACK: `${BASE_URL}/survey-feedback`,
};

export default apiRoutes;
